import { render } from "./HomeActionsBarAlbumPicker.vue?vue&type=template&id=0f251c66"
import script from "./HomeActionsBarAlbumPicker.vue?vue&type=script&lang=js"
export * from "./HomeActionsBarAlbumPicker.vue?vue&type=script&lang=js"
script.render = render

export default script